module.exports = __webpack_public_path__ + "img/full-slide-4.b25a666b.jpg";